var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"label":"","color":_vm.item.is_active ? 'green' : 'red',"outlined":""}},[_vm._v(" "+_vm._s(_vm.item.is_active ? _vm.$t('page.surveys.labels.active') : _vm.$t('page.surveys.labels.disabled'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }